"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var userAsLdUser = function (user) {
    var _a, _b, _c, _d;
    var organizationId = (_a = user.currentOrganization) === null || _a === void 0 ? void 0 : _a.id;
    var customerId = (_b = user.currentOrganization) === null || _b === void 0 ? void 0 : _b.customer.id;
    var customerName = (_c = user.currentOrganization) === null || _c === void 0 ? void 0 : _c.customer.name;
    var customerPlan = (_d = user.currentOrganization) === null || _d === void 0 ? void 0 : _d.customer.plan.name;
    return {
        firstName: user.firstName || undefined,
        lastName: user.lastName || undefined,
        custom: __assign(__assign(__assign(__assign(__assign({}, (customerId ? { customerId: customerId } : {})), (customerName ? { customerName: customerName } : {})), (customerPlan ? { customerPlan: customerPlan } : {})), (organizationId ? { organizationId: organizationId } : {})), { roles: user.roles || [] }),
        email: user.primaryEmail || undefined,
        key: user.id
    };
};
exports["default"] = userAsLdUser;
//# sourceMappingURL=convert-user-to-ld-user.js.map